export default {
  "navbar": {
    "logo": {
      "link": "#"
    },
    "list": [
      {
        "name": "最新动态",
        "link": "https://www.infoq.cn/zones/google/cloud/#message",
        "是否显示": true
      },
      {
        "name": "精彩活动",
        "link": "https://www.infoq.cn/zones/google/cloud/#activity",
        "是否显示": true
      },
      {
        "name": "白皮书",
        "link": "https://www.infoq.cn/zones/google/cloud/#whitePaper",
        "是否显示": true
      },
      {
        "name": "技术指南",
        "link": "https://www.infoq.cn/zones/google/cloud/#guide",
        "是否显示": true
      },
      {
        "name": "客户案例",
        "link": "https://www.infoq.cn/zones/google/cloud/#case",
        "是否显示": true
      },
      {
        "name": "PSO专业服务",
        "link": "https://www.infoq.cn/zones/google/cloud/#pso",
        "是否显示": true
      },
      {
        "name": "游戏专栏",
        "link": "https://www.infoq.cn/zones/google/cloud/game",
        "是否显示": true
      },
      {
        "name": "Next ’20 专栏",
        "link": "https://www.infoq.cn/zones/google/cloud/next",
        "是否显示": true
      }
    ]
  },
  "scroll": {
    "list": [
      {
        "title": "安全",
        "text": "世界一流的安全机制帮助您降低风险"
      },
      {
        "title": "多云端",
        "text": "混合云和多云端为您带来更多选择"
      },
      {
        "title": "全托管式运营",
        "text": "无服务器产品让一切更简单"
      },
      {
        "title": "嵌入式 AI 和机器学习",
        "text": "通过 AI 和机器学习推动创新"
      },
      {
        "title": "GOOGLE 一站式服务",
        "text": "借助全套云服务实现现代化"
      },
      {
        "title": "集成开源软件",
        "text": "使用托管式开源软件进行开发"
      },
      {
        "title": "世界一流的基础架构",
        "text": "依赖于 Google 的全球网络"
      }
    ]
  },
  "guide": {
    "title": {
      "mainTitle": "独家技术指南",
      "subTitle": "Google Cloud 技术专家撰写的独家技术文档为你指点迷津"
    },
    "list": [
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/rWmc3RYmecbWgFCpXl93",
        "title": "实现标记自动化：将海量元数据引入 Data Catalog"
      },
      {
        "title": "新的 Dataproc 可选组件支持 Apache Flink 和 Docker",
        "link": "https://www.infoq.cn/zones/google/cloud/article/sJF3AgFa1VbqJ2jatrNd"
      },
      {
        "title": "快速搭建Cloud Spanner DevOps环境",
        "link": "https://www.infoq.cn/zones/google/cloud/article/PiuP99XweoIJV08UCxZi"
      },
      {
        "title": "GKE上通过Istio控制微服务间流量",
        "link": "https://www.infoq.cn/zones/google/cloud/article/ZLh2xeSBwEU4GURNelPy"
      },
      {
        "title": "阿里云虚机应用程序通过VPN访问谷歌云API",
        "link": "https://www.infoq.cn/zones/google/cloud/article/f7CR0ZCv9TVU7A11AfJY"
      },
      {
        "title": "从 MySQL 迁移到 Cloud Spanner",
        "link": "https://www.infoq.cn/zones/google/cloud/article/saTVrVw5K3oAgQRXOG4o"
      },
      {
        "title": "GCS FUSE 在 Windows 环境下的解决方案",
        "link": "https://www.infoq.cn/zones/google/cloud/article/Dl2C606WmCpy7HehMXiQ"
      },
      {
        "title": "Google Cloud Storage Signed URL",
        "link": "https://www.infoq.cn/zones/google/cloud/article/Wz2EraagwqAWGIlvpPPI"
      },
      {
        "title": "从DynamoDB到Cloud Spanner",
        "link": "https://www.infoq.cn/zones/google/cloud/article/qTeWewrzIyAkXg3H0ddf"
      },
      {
        "title": "利用 LookML 项目导入功能简化代码可复用性",
        "link": "https://www.infoq.cn/zones/google/cloud/article/kQk9fD4wLVWp2Ovmukc9"
      },
      {
        "title": "GitOPS 与 Anthos Config Management",
        "link": "https://www.infoq.cn/zones/google/cloud/article/9lZ2YaiqiWkOjCl45As2"
      },
      {
        "title": "Anthos Config Management 快速入门",
        "link": "https://www.infoq.cn/zones/google/cloud/article/kpc2QB9WRaAqDysh24Sa"
      },
      {
        "title": "关于 Cloud Spanner，DBA（数据库管理员）需要了解哪些内容？",
        "link": "https://www.infoq.cn/zones/google/cloud/article/EIyEK5gA1EvQr20TTUha"
      },
      {
        "title": "为 Cloud Spanner 引入 Hibernate ORM 以便使用数据库",
        "link": "https://www.infoq.cn/zones/google/cloud/article/rpdeSpKo0w4K8DFiayKF"
      },
      {
        "title": "使用Binary Authorization实现Container Image的安全控制",
        "link": "https://www.infoq.cn/zones/google/cloud/article/BfehlmAdIDdtob3RwOyH"
      },
      {
        "title": "Ingress for Anthos",
        "link": "https://www.infoq.cn/zones/google/cloud/article/C9Y9yc1xAl11rfh3fbJT"
      },
      {
        "title": "Google Cloud 如何自定义 Google 计算引擎主机名",
        "link": "https://www.infoq.cn/zones/google/cloud/article/wkX6GKfwO62hCp75t7ws"
      },
      {
        "title": "教程：利用 Memorystore for Redis 创建游戏排行榜",
        "link": "https://www.infoq.cn/zones/google/cloud/article/0pK0lghgroDGCOh13vFz"
      },
      {
        "title": "GKE 上同一组 pod 同时支持多种 Service 模式",
        "link": "https://www.infoq.cn/zones/google/cloud/article/1mhQjhhAf6K6F1IGaNaC"
      },
      {
        "title": "云游戏基础架构概览",
        "link": "https://www.infoq.cn/zones/google/cloud/article/6veKmow7yHq6Ue2fU3g2"
      },
      {
        "title": "非 Org Project 迁移到 Org Project",
        "link": "https://www.infoq.cn/zones/google/cloud/article/QCcZ2d74ETJ5ejXhM3Xj"
      },
      {
        "title": "专用游戏服务器迁移指南",
        "link": "https://www.infoq.cn/zones/google/cloud/article/6wMwgyhJGylJwKgBfBF6"
      },
      {
        "title": "GKE 创建 Pod 采用 Regional Disk 的实现",
        "link": "https://www.infoq.cn/zones/google/cloud/article/L2VCBUzTS6DN9uTfML23"
      },
      {
        "title": "使用数据流转换和导出 CDN 日志",
        "link": "https://www.infoq.cn/zones/google/cloud/article/W6wbBCONHCfGiLgRU5Wz"
      },
      {
        "title": "Google Cloud VPC Peering 广播动态路由",
        "link": "https://www.infoq.cn/zones/google/cloud/article/diC7XBvhhR8lPTOgWhlX"
      },
      {
        "title": "使用 GKE Connect 管理微软 AKS 服务",
        "link": "https://www.infoq.cn/zones/google/cloud/article/XpQVcbiIZPFZ08wyxGwD"
      },
      {
        "title": "通过 BigQuery 查询 Http 负载均衡流量信息的实现方法",
        "link": "https://www.infoq.cn/zones/google/cloud/article/zStoIm8FGfuUA7ec7wjY"
      },
      {
        "title": "GKE 多种 Ingress 的实现",
        "link": "https://www.infoq.cn/zones/google/cloud/article/FwOkvi6zuxDSsiALsaHz"
      },
      {
        "title": "使用 Nginx 实例组实现 CDN 外部源站",
        "link": "https://www.infoq.cn/zones/google/cloud/article/GTyKaUpiz7sVbU36U9PY"
      },
      {
        "title": "使用 GCP 的 IAP 功能实现 VM 无公网 IP 的 SSH 登陆 ",
        "link": "https://www.infoq.cn/zones/google/cloud/article/omcQHjLCFFsFwJti2OOq"
      },
      {
        "title": "Google Cloud 导入标准 CentOS 镜像 ",
        "link": "https://www.infoq.cn/zones/google/cloud/article/B5DBf7kOVhshFpPKCTUN"
      },
      {
        "title": "Google Cloud IAM 中添加自定义域名",
        "link": "https://www.infoq.cn/zones/google/cloud/article/wglK2TS7V1kD0P9lChjS"
      },
      {
        "title": "GCP的HTTP(S)负载均衡添加User-Defined Header",
        "link": "https://www.infoq.cn/zones/google/cloud/article/PO42q76XVaNZWDgo4eWr"
      },
      {
        "title": "创建阿里云OSS到GCS的自动同步",
        "link": "https://www.infoq.cn/zones/google/cloud/article/Q5vBhqufWw3Kh3PyRwa3"
      },
      {
        "title": "GCE+辅助 IP，实现基于 Keepalived 和 MySQL 的高可用集群",
        "link": "https://www.infoq.cn/zones/google/cloud/article/Pa3i4b9ySL9SavBtaLgO"
      },
      {
        "title": "GCP平台基于日志创建自定义的metric进行监控",
        "link": "https://www.infoq.cn/zones/google/cloud/article/WXui5fVbpM0Y2KaG8dE0"
      }
    ],
    "button": {
      "link": "https://www.infoq.cn/zones/google/cloud/list?id=2",
      "text": "查看更多"
    }
  },
  "questionnaire": {
    "title": "Google Cloud 调查问卷",
    "button": {
      "link": "https://services.google.cn/fb/forms/contenthubfeedback/",
      "text": "立即参与"
    }
  },
  "message": {
    "title": {
      "mainTitle": "最新动态",
      "subTitle": "这里包含你想知道的 Google Cloud 技术趋势与最新解读"
    },
    "list": [
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/H5K0oGXtWV9fokNZTsj2",
        "imgSrc": 'https://static001.geekbang.org/resource/image/11/eb/11360aeac16d05085882ee38aa7fc0eb.png',
        "origin": "数据库",
        "title": "利用 Cloud SQL 在假日购物季防止计划停机",
        "text": "Cloud SQL 涵盖了 MySQL、PostgreSQL 和 SQL Server 的完全托管数据库服务，现在为您提供更多的控制，让您能够掌控您的实例进行日常维护的时间。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/u4mD5kVvAcMGPHAdJ5AN",
        "imgSrc": 'https://static001.geekbang.org/resource/image/51/40/5111997d6fb85d599acc5fc65f9d0b40.png',
        "origin": "数据库",
        "title": "MySQL 8 已经为采用 Cloud SQL 的企业准备就绪",
        "text": "我们已经将MySQL 8 与 Cloud SQL 的高可用性配置和安全控制完全集成，以确保您的 MySQL 8 数据库实例已经为企业准备就绪。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/ElxWMNkq5MywJtJmO9y6",
        "imgSrc": 'https://static001.geekbang.org/resource/image/bf/59/bf66a87d84fcdyy503150e6e82e1ed59.png',
        "origin": "数据库",
        "title": "针对 Memorystore for Redis 的性能优化最佳实践",
        "text": "在本文中，我们将介绍您能如何衡量 Memorystore for Redis 的性能以及性能调整的最佳实践。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/SOA0TPp6l0O0Xz0ptOrh",
        "imgSrc": 'https://static001.geekbang.org/resource/image/03/a0/035058d2958aaa661445783e29fab0a0.jpg',
        "origin": "企业文化",
        "title": "培养创新文化：从 Google 学到的五堂课",
        "text": "本文中，Google 副总裁兼首席互联网传播官 Vinton G. Cerf 分享了五堂关于培养创新文化的课程。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/wtxHlFetRKdaas995fsw",
        "imgSrc": 'https://static001.geekbang.org/resource/image/c3/6e/c3b4b105b010051fa4a0802dc900fb6e.png',
        "origin": "AI和机器学习",
        "title": "Recommendations AI 让线上购物变得更加个性化",
        "text": "无需手动制定规则或在本地管理繁琐的推荐模型，您可以直接通过使用 Recommendations AI 替换或补充现有解决方案来升级个性化策略。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/KWQ53sWB5XkJIg3xTj4H",
        "imgSrc": 'https://static001.geekbang.org/resource/image/c1/d3/c14264408aec2c61fac9c6acebfbd9d3.png',
        "origin": "企业服务",
        "title": "IDC 研究显示，Google Cloud Platform 以 222% 投资回报率强势助力中小企业加速业务增长",
        "text": "通过内置智能分析与人工智能功能带来的强大设计能力、开放性、可靠性与创新空间，Google Cloud成为众多中小型企业的选择。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/DxXF2ZNfRHmRZGPfE0xO",
        "imgSrc": 'https://static001.geekbang.org/resource/image/16/b2/16a800ae596e2008yy188a9e17d734b2.png',
        "origin": "人工智能与机器学习",
        "title": "凭借全球最快训练超级计算机，Google 在 MLPerf 测试中打破 AI 性能记录",
        "text": "Google 近期亦推出一系列 ML 提升方案，包括实用度更高的搜索结果以及一套能够翻译上百种不同语言的 ML 模型。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/fRh4i2cl5WiErLittmwY",
        "imgSrc": 'https://static001.geekbang.org/resource/image/40/d3/40066819d968f11dc330e766fa8080d3.png',
        "origin": "行业",
        "title": "Google Cloud在Forrester Wave 2020年API管理解决方案报告中获领导者评级",
        "text": "orrester Research等行业分析公司专门就此发布研究报告，可帮助企业评估并选择适合自身需求的正确解决方案。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/2qe1jpGoKMOX1fDSFcwg",
        "imgSrc": 'https://static001.geekbang.org/resource/image/a5/d7/a58f1320024720392b205af08348bbd7.png',
        "origin": "API管理",
        "title": "由 API 驱动的数字生态系统如何推动创新和效率",
        "text": "Google Cloud 的 Apigee API 管理平台提供一套立足完整生命周期管理 API 的统一方法，同时也为企业提供必要的数字工具，借此建立起深入的、集成业务的合作伙伴关系乃至活跃的开发者社区。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/EKfqepsgvP0kOQ71SSEa",
        "imgSrc": require('../assets/img/google-img/0721.png'),
        "origin": "混合云",
        "title": "Google早已看到未来多容器的挑战，利用Anthos能否实现多集群统一管理？",
        "text": "大部分企业还在寻找好用的 Kubernetes(k8s)。而作为 k8s 的开创者，当大家都在讲 Docker 时，Google 已经开始讲 k8s，并有了 GKE这样的容器管理工具，大家开始讲 k8s 时，Google 开始讲多容器集群管理，并推出了 Anthos 这样的多集群管理平台。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/eJW9S8mKr3P7SW7IToxh",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/c9/12/c9d794ba16b2c41cd01da8acee4b5b12.png",
        "origin": "基础设施",
        "title": "Google Cloud 雅加达数据中心现已开放",
        "text": "雅加达区域（asia-southeast2）的建立，使得 GCP 能够更靠近我们的客户及其用户。它可以降低对数据和应用的访问延迟，帮助在印尼开展业务的公司，加速数字化转型。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/B6q3BLpRdTzPJPeB0XIi",
        "imgSrc": "https://static001.geekbang.org/resource/image/31/d6/31ef9554c7b4e3cbe5fb9c44f51a44d6.png",
        "origin": "广告营销",
        "title": "Ads Data Hub：让营销更快更简单",
        "text": "广告主认为，明确营销活动对业务的作用，在当下至关重要。随着关于隐私保护的讨论越来越多，行业不得不改变收集和使用数据的方式，这也让对营销活动全面复盘，变得越来越困难。Ads Data Hub 能够对您的 Google 广告投放进行定制化分析，同时遵守 Google 严密的数据安全准则，保护用户隐私。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/GARChRo3cPZ1DeCULYf3",
        "imgSrc": "https://static001.geekbang.org/resource/image/9f/b3/9f578a0e7ce9bd914b3e31c6f940a5b3.png",
        "origin": "协同办公",
        "title": "我们将推出呼声最高的 4 项 Google Meet 功能",
        "text": "为确保公众的安全与健康，远程办公日显必要，这就要求员工即使相隔异地，也能随时保持联系，尤其在当下更是如此。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/lAdsrt8batFV15zV9PLf",
        "imgSrc": "https://static001.geekbang.org/resource/image/52/d9/5204eed357fb587cdb795eb606c7cdd9.png",
        "origin": "混合云",
        "title": "Anthos：针对应用的多云管理平台",
        "text": "Anthos 的意义远不止于一次性的应用现代化；它关乎如何在一个日益混合云 / 多云的世界中，高效地构建、部署和运行应用。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/HqyKlEU0jjWOQdVa722v",
        "imgSrc": "https://static001.geekbang.org/resource/image/8a/28/8a3ef8d866b82fb0444bae11be0eb528.png",
        "origin": "混合云",
        "title": "Anthos 驱动业务敏捷性和效率",
        "text": "按需灵活地运行应用程序，减少复杂性，一直是选择 Anthos 的首要考虑–许多客户希望继续使用现有的基础设施，无论是私有部署还是在其他云服务中，一个共同的管理层级，有助于团队以低成本来交付保证高质量的服务。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/bsxwGTGuyh9j9PbIPlly",
        "imgSrc": "https://static001.geekbang.org/resource/image/61/66/6174fd5677f83e06f1f7703d5acb7a66.png",
        "origin": "数据管理",
        "title": "Kubernetes 上是否运行数据库，取决于哪些因素？",
        "text": "越来越多的应用部署在 Kubernetes 上的容器中，因此 Kubernetes 也被称为「云端的 Linux」。尽管在应用层（application layer）的容器化有了大量增长，但数据层（data layer）在容器化方面得到的关注并不多。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/XZ1dLCEFdGRQAbiiyhrt",
        "imgSrc": "https://static001.geekbang.org/resource/image/73/ca/736d9a4a90adc9216cbdce6d0c8505ca.png",
        "origin": "管理工具",
        "title": "Google 操作（Ops）产品迎来全面整合",
        "text": "如今，我们已经跨过新的重要里程碑，决定将各项操作功能全面集成至 Google Cloud Console 当中。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/mye0rLhpbDdUvPfbAFr0",
        "imgSrc": "https://static001.geekbang.org/resource/image/7b/e0/7bacc829fa51f67c7b0dbb451f745de0.png",
        "origin": "游戏",
        "title": "专为简化全球化游戏管理而生：Game Servers 发布 beta 版本",
        "text": "为了给玩家带来超越期望的多人游戏体验，游戏开发人员如今更倾向于选择专用游戏服务器作为玩家接入的默认选项。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/twUIDQ9jciLigEGbfp0x",
        "imgSrc": "https://static001.geekbang.org/resource/image/53/2c/534189c0fcbde4d4f4a59a30fe8d292c.png",
        "origin": "游戏",
        "title": "Agones：一款基于 Kubernetes 的开源游戏服务器",
        "text": "在分布式系统领域，支持在线弹性扩展，实时多人专属游戏服务器意味着特殊的挑战。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/tq2iqCYZytyl7vrujJRv",
        "imgSrc": "https://static001.geekbang.org/resource/image/5c/19/5c007c7ed86dc9beaf07452db87f0619.png",
        "origin": "行业",
        "title": "Google 荣获 Gartner 2020 年 Cloud AI 开发者服务魔力象限领导者评级",
        "text": " Gartner 公司在最新一期《Gartner 2020 年 Cloud AI 开发者服务魔力象限》报告中，将 Google 列为行业领导者。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/3CU8SI0YO9Hm2t3Z7sco",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/84/0f/84ad239e17b87ea08b88a60741108e0f.png",
        "origin": "混合云",
        "title": "降低应用程序现代化门槛：Anthos 为混合云环境带来托管服务网格与无服务器解决方案",
        "text": "数十年来，各类组织机构一直在自有数据中心之内构建并运行各类应用程序。不过面对近几年如火如荼的云计算革命，在云端部署及运行应用程序也开始成为一类重要运营选项。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/sQGW9Ub1HeIz7ycVfF45",
        "imgSrc": "https://static001.geekbang.org/static/business/img/dongtai-big.ca0d0462.jpg",
        "origin": "数据分析",
        "title": "BigQuery 数据转换简化大法：让机器学习更轻松高效",
        "text": "我们宣布在 BigQuery ML 中添加一系列新功能，帮助用户通过简单的SQL函数实现数据的预处理与转换。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/MYAgDPldb53O4zmhjhei",
        "imgSrc": "https://static001.geekbang.org/static/business/img/dongtai-2.6e85a024.jpg",
        "origin": "行业",
        "title": "Gartner 发布最新魔力象限报告，Google Cloud 跻身运营数据库管理系统领导者",
        "text": "Gartner 在其2019年《运营数据库管理系统（OPDBMS）魔力象限》报告中，将 Google Cloud 列入领导者区间。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/SHR6KFboNRRlN3GidGgB",
        "imgSrc": "https://static001.geekbang.org/static/business/img/dongtai-apex.fae19c16.jpg",
        "origin": "游戏",
        "title": "Google Cloud 助力 Multiplay 创下 Apex Legends 首发纪录",
        "text": "凭借着一流的云服务器编排框架以及24/7/365全天候专业服务团队，Multiplay 得以顺利支持游戏极速飙升的人气。这套编排框架采用 Google Cloud。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/rVSrxPwl3EQv3yklEBxT",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/7e/8a/7ea3af94afa90433d93d54c194524f8a.png",
        "origin": "AI 和机器学习",
        "title": "AI 发展迎来下一轮突破，无数虚拟世界蕴藏其中",
        "text": "2012年，ImageNet 训练数据集的正式亮相在人工智能开发领域掀起一波巨浪。在实际应用角度来看，此次浪潮带来的最引人注目的成功案例，无疑是AI 视觉模型。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/SkAsEJiyKD4UuOewXDrv",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/9c/39/9c51adeffb00e2700691c8dd432f8839.png",
        "origin": "无服务器",
        "title": "托管 Knative 服务 Cloud Run 正式迎来通用版本",
        "text": "对于企业而言，无论是在内部运行 Kubernetes 环境，还是选择全托管型无服务器计算平台，我们的目标都始终明确：为开发人员赋能。今天，我们宣布谷歌云正式发布 Cloud Run 通用版本。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/jE7usKLrwoEYBYYaHYC3",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/95/43/9555ae7298db5e29836d7e0ee6511443.png",
        "origin": "AI 和机器学习",
        "title": "将 Google AutoML 带给 Kaggle 上的 350 万数据科学家",
        "text": "最近，Kaggle 项目的发展迎来重大里程碑——利用这套平台学习并运用机器学习技术的用户已经超过350万。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/ZMQvH4oG6VBs25yP5V2q",
        "imgSrc": "https://static001.geekbang.org/static/business/img/dongtai-big.ca0d0462.jpg",
        "origin": "数据分析",
        "title": "在通往现代数据分析的道路上，BigQuery已经成为重要领航者",
        "text": "众多企业与数字化机构已经选择 Google Cloud 智能分析平台，借此从自有数据当中挖掘出不可思议的巨大价值。而这套智能分析平台的核心正是 BigQuery。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/BdT7VNSafSqWKGiuqtQF",
        "imgSrc": "https://static001.infoq.cn/resource/image/6c/0c/6ca0bc7b0614be0b6bc805ab250dfc0c.png",
        "origin": "行业",
        "title": "Forrester Wave报告将Google Cloud列为分析数据管理市场领导者",
        "text": "Forrester 公司在其《Forrester Wave™：2020 年第一季度分析数据管理（DMA）》报告中，将 Google Could 列为市场领导者。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/RJXSj4YXSjpac9Qh6W7R",
        "imgSrc": "https://static001.infoq.cn/resource/image/b8/31/b8176e2d0b8ff5f42c0bbdba10767d31.png",
        "origin": "数据库",
        "title": "将您的Microsoft SQL Server工作负载迁移至Google Cloud",
        "text": "从微软SQL Server 2008迁移至Cloud SQL for SQL Server，只需要五个简单步骤即可实现。"
      }
    ],
    "button": {
      "link": "https://www.infoq.cn/zones/google/cloud/list?id=0",
      "text": "查看更多"
    }
  },
  "activity": [
    {
      "imageList": 'https://static001.geekbang.org/resource/image/45/05/4519yy948a929d040f7c65688dcd9c05.png',
      "textInfo": {
        "top": {
          "mainTitle": "精彩活动",
          "subTitle": "与专家交流互动，了解有关 Google Cloud 的更多资讯"
        },
        "bottom": {
          "title": "出海纪 | Google Cloud 今日谈 对话 TiDB 核心数据库上云秘籍",
          "time": "2020年10月22日 13:30-14:30",
          "address": "线上分享",
          "text": "PingCAP 打造了国内第一个 NewSQL 开源项目——TiDB ，在核心数据库上云领域有着非常硬核的实战经验，而 Google Cloud 在云计算和大数据技术的落地实践上也是佼佼者，这一场强强碰撞的对话一定能给你带来更多关于数据库上云的思考、灵感。"
        }
      },
      "button": {
        "link": "https://uao.so/spw422464",
        "text": "查看活动"
      }
    },
    {
      "imageList": require('../assets/img/google-img/activity7.png'),
      "textInfo": {
        "top": {
          "mainTitle": "精彩活动",
          "subTitle": "与专家交流互动，了解有关 Google Cloud 的更多资讯"
        },
        "bottom": {
          "title": "为游戏厂商搭建高效强大的营销平台",
          "time": "2020年7月30日 15:00-16:00",
          "address": "线上分享",
          "text": "Google Cloud 提供丰富的数据分析和人工智能产品，企业可以快速打造用户行为分析和预测工具，并根据预测结果自动进行广告投放和评估，形成完整闭环。"
        }
      },
      "button": {
        "link": "http://cloudonair.vhall.com/live/detail/id/139.html",
        "text": "查看活动"
      }
    },
    {
      "imageList": "https://static001-test.geekbang.org/resource/image/ca/e6/ca7eaf0c4c538046013a07a415c5ece6.png",
      "textInfo": {
        "top": {
          "mainTitle": "精彩活动",
          "subTitle": "与专家交流互动，了解有关 Google Cloud 的更多资讯"
        },
        "bottom": {
          "title": "出海纪 | Google Cloud 今日谈 对话网易游戏：出海背后的技术密码",
          "time": "2020年4月9日 13:30-14:30",
          "address": "线上分享",
          "text": "Google Cloud 与 网易游戏 首次联手分享 “游戏出海” 的新格局，围绕游戏出海的关键性问题，网易作为在海外成功运营《阴阳师》《决战平安京》等大型游戏的行业代表公司之一，与大家聊聊如何利用 Google 的产品能力搭建海外业务架构，以及利用一些自动化方案对Google Cloud 的业务进行优化。"
        }
      },
      "button": {
        "link": "https://uao.so/spw68c30015",
        "text": "查看活动"
      }
    },
    {
      "imageList": require('../assets/img/google-img/activity4.png'),
      "textInfo": {
        "top": {
          "mainTitle": "精彩活动",
          "subTitle": "与专家交流互动，了解有关 Google Cloud 的更多资讯"
        },
        "bottom": {
          "title": "Cloud OnAir 线上课堂",
          "time": "2020年",
          "address": "线上分享",
          "text": "Cloud OnAir 是由 Google Cloud 团队发起的线上会议，定期邀请行业专家、技术大咖、客户及合作伙伴，对 Google Cloud 的产品、技术及实际使用经验，进行分享和讲解。关注 Cloud OnAir，学习如何高效上手 Google Cloud！"
        }
      },
      "button": {
        "link": "http://cms.hftty.cn/",
        "text": "更多课程回看"
      }
    }
  ],
  "whitePaper": {
    "title": {
      "mainTitle": "<span style=\"font-family: google-word\"> Google Cloud </span>白皮书",
      "subTitle": "深入介绍 GCP 与实际应用"
    },
    "list": [
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/Z9mfNKYhtVo6O6FjWafJ",
        // "downloadLink": "https://www.infoq.cn/zones/google/cloud/article/I4p8XqAjlBwMQOt9WB7g",
        "title": "Google 创新指南：解锁企业策略、资源和技术",
        "text": "在 Google 我们花费多年思考，如何维护和弘扬能促进变革和创新的企业文化。这促使我们围绕某些核心原则进行了调整，而这些原则正是政策颁布的依据，且已经支持Google文化二十余年。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/TMRPmsYdyCYKkxIizKXp",
        // "downloadLink": "https://www.infoq.cn/zones/google/cloud/article/I4p8XqAjlBwMQOt9WB7g",
        "title": "数据分析决策：建立现代数据仓库的执行手册",
        "text": "在这份白皮书中，我们将探讨现代数据仓库的关键组件，在采用云数据仓库时应该考虑什么，以及谷歌的BigQuery是如何设计来满足现代需求的。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/gVUXZlTqkfqtC1CJdyjU",
        // "downloadLink": "https://www.infoq.cn/zones/google/cloud/article/I4p8XqAjlBwMQOt9WB7g",
        "title": "数据仓库的未来",
        "text": "在本电子书中，基于Forrester分析师Michele Goetz在2019年，以“您的数据仓库的未来”数字会议上的主题演讲，我们将探讨数据仓库的演变，以及云基础设施如何为未来提供巨大的收益。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/m2hlglBlFzeee6N9jldT",
        // "downloadLink": "https://www.infoq.cn/zones/google/cloud/article/I4p8XqAjlBwMQOt9WB7g",
        "title": "Anthos 底层探秘：将重塑企业应用的技术",
        "text": "我们于 2018 年推出了 Anthos，以满足客户在应用现代化过程中任意阶段的需求。如今，我们非常高兴地看到各行各业的客户都在使用 Anthos 重塑其业务关键型应用组合。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/H27UJbMFlIlS1brEzXBg",
        // "downloadLink": "https://www.infoq.cn/zones/google/cloud/article/I4p8XqAjlBwMQOt9WB7g",
        "title": "了解费用优化的原则",
        "text": "在您为企业制定计划和设定目标时，总会有某种程度的不确定性。您永远无法预知客户对某种产品的反响如何，也无法预知销售预测是否准确。但您可以控制技术系统的运行效率，并跟踪这些系统为企业用户提供服务的情况。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/7cdpwhq5HroMDpiU16rl",
        // "downloadLink": "https://www.infoq.cn/zones/google/cloud/article/I4p8XqAjlBwMQOt9WB7g",
        "title": "基于 Looker 的现代化数据建模方法",
        "text": "作为分析师，您可能花了大量时间编写 SQL 查询来为决策者提供数据报告。而您所耗费的那些时间很快就会由数小时变为数天、数周乃至数月。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/XTpUlpo9Zvbj00mN8KDl",
        // "downloadLink": "https://www.infoq.cn/zones/google/cloud/article/I4p8XqAjlBwMQOt9WB7g",
        "title": "容器安全对业务的重要意义",
        "text": "本文档的目的在于帮您了解容器安全的基础知识，以便在您需要制定业务决策时，可以具备有助确保业务安全的背景知识。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/Bdq1wFmwEskieqUkUv1V",
        // "downloadLink": "https://www.infoq.cn/zones/google/cloud/article/I4p8XqAjlBwMQOt9WB7g",
        "title": "面向首席信息官的数据分析与机器学习指南",
        "text": "本文档以原创研究成果及 Google 在云技术领域所做的贡献为基础，旨在帮助 IT 和业务主管实施以云为导向的现代数据管理策略。在每个部分中，我们将分别介绍可帮助公司将庞大而复杂的数据资源转化为实用业务洞见的各种技术。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/YdPgVvivD0pmpwc8QAoW",
        // "downloadLink": "https://www.infoq.cn/zones/google/cloud/article/I4p8XqAjlBwMQOt9WB7g",
        "title": "应用现代化改造以及基础架构、服务与团队的解耦",
        "text": "基础架构、服务与团队的成功解耦可以最大程度地减少手动协调相关工作方面的需求，不仅能够降低费用和复杂性, 还能显著提高开发者的工作速度、运维效率和企业生产力。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/ZG1j33chtPO8VhCkBkGW",
        // "downloadLink": "https://www.infoq.cn/zones/google/cloud/article/I4p8XqAjlBwMQOt9WB7g",
        "title": "云计算的未来",
        "text": "本文档将探讨：未来的企业是什么样的；哪些基本要素帮助塑造了云企业；云计算会如何影响各个企业；业务和 IT 负责人以及决策者应如何做好准备。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/94Z4eZUt6aMzAxzVBG1F",
        // "downloadLink": "https://www.infoq.cn/zones/google/cloud/article/I4p8XqAjlBwMQOt9WB7g",
        "title": "Connect for Anthos 的安全特性",
        "text": "本文档介绍了 Connect for Anthos 内置的安全措施，这些安全措施为想要帮助保护其 GKE On-Prem 用户集群的客户提供了有力支持。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/m9WFHV6D0EWDFpGkByx4",
        // "downloadLink": "https://jinshuju.net/f/IvfuPR",
        "title": "在 Google Cloud Platform 上操作数据删除",
        "text": "本份白皮书将介绍当对保存在 GCP 内的客户数据进行删除时，系统实际执行的安全删除流程。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/RD8OeJVWizg8iX9rqBdP",
        // "downloadLink": "https://jinshuju.net/f/XjcgRx",
        "title": "在 Kubernetes 上运行您的现代 .NET 应用程序",
        "text": "本份白皮书将介绍容器与编排，并向大家展示为何以及如何将其引入 Google Cloud 的应用程序当中，最终实现云原生转型。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/W1lDNNZvglcaOHkXCfpP",
        // "downloadLink": "https://jinshuju.net/f/4pexK5",
        "title": "数据突发事件响应流程",
        "text": "本份白皮书将介绍 Google Cloud 严格的数据事故管理流程。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/DRAjvegxNuL5R8ulPeZr",
        // "downloadLink": "https://jinshuju.net/f/n92l7b",
        "title": "Google 安全性白皮书",
        "text": "本份白皮书概述了 Google 在 Google Cloud 公有云产品与服务组合当中使用的安全性与合规性方法。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/d7vs4rUAszff060i865s",
        // "downloadLink": "https://jinshuju.net/f/IvfuPR",
        "title": "Kubernetes：你的混合云战略",
        "text": "本白皮书主要探讨 Kubernetes 如何为大家的混合云发展战略提供答案，以及如何建立起一套用于简化部署、管理以及运营问题的整体性解决方案。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/jY3gOHmE8I4RNpxr8sSb",
        // "downloadLink": "https://jinshuju.net/f/XjcgRx",
        "title": "将工作负载迁移至公有云环境：基础指南与事项清单",
        "text": "本份白皮书整理出相关提示，希望帮助 IT 部门分步完成整个迁移流程中的四大基本环节：评估、规划、迁移以及优化。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/U8icPCW6WyARog41jJ4Y",
        // "downloadLink": "https://jinshuju.net/f/4pexK5",
        "title": "Google BigQuery 深度剖析报告",
        "text": "本白皮书旨在介绍 Google BigQuery，这是一项全托管云服务，为用户提供面向海量数据的交互式查询功能。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/pBkxEv27N4B3XPOFEUuj",
        // "downloadLink": "https://jinshuju.net/f/g1z7bn",
        "title": "关于 Google Cloud Anthos 的五个常见问题",
        "text": "在 Kubernetes 以及其他多种开源技术的支持之下，Anthos 也成为目前市面上唯一一套基于软件的混合平台。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/yviFjZTpZDRP9bwMF9Pw",
        // "downloadLink": "https://jinshuju.net/f/9tc8V5",
        "title": "云端数据治理原则与最佳实践",
        "text": "如果大家有意将数据迁移至云端，本份白皮书希望为您提供在此期间与数据治理相关的指导意见与最佳实践。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/I4p8XqAjlBwMQOt9WB7g",
        // "downloadLink": "https://jinshuju.net/f/9tc8V5",
        "title": "Anthos 实现应用程序安全现代化的绝佳机遇",
        "text": "通过本文档，您可以了解现代应用程序中的安全挑战，混合与多云环境下的安全现代化方案。"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/RadNu2Hwu34egL093hl5",
        // "downloadLink": "https://jinshuju.net/f/9tc8V5",
        "title": "面向用户的现代口令安全性指南",
        "text": "本份白皮书主要面向需要使用身份验证功能的在线应用用户，内容涵盖口令功能指南与使用建议"
      }
    ],
    "button": {
      "link": "https://www.infoq.cn/zones/google/cloud/list?id=1",
      "text": "查看更多"
    }
  },
  "case": {
    "title": {
      "mainTitle": "客户和案例研究",
      "subTitle": "借力云端技术，携手合作伙伴"
    },
    "listTop": [
      // {
      //   "imgSrc": "https://static001.infoq.cn/resource/image/de/5c/dea2e7c4136c4cdb55f9a34248c19d5c.jpg",
      //   "videoSrc": "https://media001.geekbang.org/customerTrans/8ea7d4d8f077bad948e0480848916f24/51de00a-170c43e65c6-0000-0000-01d-dbacd.mp4",
      //   "origin": "音乐",
      //   "title": "GCP 帮助 Spotify 实现数据挖掘，带给你专属音乐体验"
      // },
      // {
      //   "imgSrc": "https://static001.infoq.cn/resource/image/c5/ef/c582a4b4de319e17a9cecfa51faa2bef.jpg",
      //   "videoSrc": "https://media001.geekbang.org/customerTrans/8ea7d4d8f077bad948e0480848916f24/6da8f11-170c43e6368-0000-0000-01d-dbacd.mp4",
      //   "origin": "零售",
      //   "title": "Google Cloud 带给 Kohl's 的零售创新"
      // },
      // {
      //   "imgSrc": "https://static001.geekbang.org/static/business/img/video1.b67ae10e.png",
      //   "videoSrc": "https://media001.geekbang.org/customerTrans/8ea7d4d8f077bad948e0480848916f24/47c9f83d-16f843c6415-0000-0000-01d-dbacd.mp4",
      //   "origin": "零售",
      //   "title": "认识 ShopBot：eBay 的新AI购物助手"
      // },
      // {
      //   "imgSrc": "https://static001.geekbang.org/resource/image/e8/df/e817a942e3008e503c9ddd3ba231c2df.png",
      //   "videoSrc": "https://media001.geekbang.org/9938a7cf24754e29bc2a741e378bb679/63903459e242493d96ad491db95a5a0c-bbd0fa0398be9cdf06950bb5c176279a-hd.mp4",
      //   "origin": "社交网络",
      //   "title": "Twitter 拥抱谷歌云"
      // },
      // {
      //   "imgSrc": "https://static001.geekbang.org/static/business/img/video2.5a887292.png",
      //   "videoSrc": "https://media001.geekbang.org/customerTrans/8ea7d4d8f077bad948e0480848916f24/38067503-16f846d4a21-0000-0000-01d-dbacd.mp4",
      //   "origin": "游戏",
      //   "title": "Google Cloud 助力 Pocket Gems"
      // },
      // {
      //   "imgSrc": "https://static001.geekbang.org/resource/image/9e/03/9e2cb5140592f00eeda4f953619c3703.png",
      //   "videoSrc": "https://media001.geekbang.org/f3f8f4ec2d114d77a461de80c83c4e9b/6863d76d76584627be8d55a6da8bd5b2-46b2ca75cac19ee9ae3f79a251a59c06-hd.mp4",
      //   "origin": "零售",
      //   "title": "Google Cloud 帮助 DSW 实时吸引超过2千8百万的鞋迷"
      // },
      // {
      //   "imgSrc": "https://static001.geekbang.org/resource/image/de/cb/de3457808b0c2804ca47d51e92d434cb.png",
      //   "videoSrc": "https://media001.geekbang.org/5b10e986933b47c7a3dd75607edd7b61/dea62b471db141d4a4205637bc4d6f56-4921ee19c6a310ff96aaf104fff80302-hd.mp4",
      //   "origin": "游戏",
      //   "title": "在 Google Cloud Platform 上构建游戏"
      // }
    ],
    "listBottom": [
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/Yblzq6RY0KYFZZRIwJzA",
        "origin": "数据分析",
        "title": "琥珀移动：基于用户使用数据分析，提供个人化的天气预报应用服务",
        "text": "使用 Firebase 的同时，琥珀移动也用 BigQuery 来提供更理想的分析工具。琥珀移动之所以会特别选择这两个 Google Cloud 的产品，是因为当时这两个产品是市场上功能最强大的。",
        "imgSrc": "https://static001.geekbang.org/resource/image/a1/d0/a1ec97e98d7ab2d9bcyy43698a51cbd0.png"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/T0HtsFEDLmIBxl3J7A2G",
        "origin": "游戏开发",
        "title": "祖龙娱乐：为全世界的玩家带来沉浸式的在线游戏体验",
        "text": "Google Cloud 为祖龙娱乐提供了定制化的服务方案，这让配置比例使用起来更加符合其需求。在享受合适的产品配置及高弹性服务的同时，进一步降低了使用成本。",
        "imgSrc": "https://static001.geekbang.org/resource/image/da/71/dab56b97d8ff8088f03e226895e7bc71.png"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/RXCcKX7PKIXxALdWmGBg",
        "origin": "游戏开发",
        "title": "King 使用 Looker 打造更有趣的游戏",
        "text": "在这个充满竞争的快节奏市场中，成功的关键在于打造始终有趣好玩的游戏。如果游戏太简单，玩家会觉得索然无味；而如果太难，他们会产生挫败感。从一开始，King 便依靠分析来帮助开发人员在简单和困难之间实现完美平衡。",
        "imgSrc": "https://static001.geekbang.org/resource/image/c1/42/c1ede7e63e220837564fc338553e0f42.png"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/H5UG2yXJou79PypU7d4v",
        "origin": "计算",
        "title": "90 Seconds ：用 Google Cloud 链接创作达人和客户",
        "text": "通过 Google Cloud，90Seconds 提供了可靠的、可扩展的云视频制作工具，并利用机器学习技术为改进视频分析铺平了道路。",
        "imgSrc": "https://static001.geekbang.org/resource/image/01/4c/0158d5a7153c43c2ebe3725764e3854c.jpg"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/44kSX92rXHNENphObwIw",
        "origin": "计算",
        "title": "BQ：为移动创新注入活力",
        "text": "借助 GCP（Google Cloud Platform） 上的 GKE（Google Kubernetes Engine）和 BigQuery，BQ 得以用更低的成本，提供更好的服务，提高其针对大型制造商的竞争优势。",
        "imgSrc": "https://static001.geekbang.org/resource/image/4e/03/4ee3f73ecf306c45f96bab88b2cbdf03.jpg"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/BCtHauErzrpwDZPRgOmR",
        "origin": "计算",
        "title": "17 Media：用 Google Cloud 应对直播流量激增",
        "text": "使用 Google Cloud 平台，17 Media 获得了可扩展性、可用性和响应性，以支持其快速增长的视频流服务，以及实时分析用户数据以获得更有效的决策。",
        "imgSrc": "https://static001.geekbang.org/resource/image/11/fa/11f569857ad0b76b19135ee7c0bb01fa.jpg"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/ysWyM4ISfRvqoyMtr7Xr",
        "origin": "游戏",
        "title": "《七龙珠：武斗传奇》与 GCP 后端",
        "text": "BNE 早在 2017 年 2 月就开始与 Google Cloud 沟通，探讨这款游戏可能面临的种种挑战，希望 Google 能够提供足以应对各类实际负载难题的强大云基础设施。",
        "imgSrc": "https://static001-test.geekbang.org/resource/image/90/fd/909473593db0bcd3d4b2bebe773323fd.png"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/hOKLtmS7kLWWeHXH1pbE",
        "origin": "科技",
        "title": "Castbox：使用 Google Cloud Platform 向用户传达声音",
        "text": "在 Google Cloud Platform 与 Firebase 的有力支持之下，Castbox 得以运行起高度可扩展的语音音频内容平台，同时提供音频内搜索与精选播客推荐等一系列智能功能。",
        "imgSrc": "https://static001.geekbang.org/static/business/img/anli-cast.f70c913c.png"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/IG8q3eilZlN5rHEVUOow",
        "origin": "电信、媒体和娱乐",
        "title": "一加：通过 Google Cloud 的 AI 模型提供准确的用户反馈分析",
        "text": "一加（OnePlus）在 Cloud AutoML 上训练机器学习模型，以分析用户反馈，无需编写代码。",
        "imgSrc": "https://static001.geekbang.org/resource/image/69/3f/698573b635f1aea0c0b8da7bba58d73f.jpg"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/aaBaSCcKv1Brl31a70yj",
        "origin": "媒体和娱乐",
        "title": "ELEX：为数十万并发聊天用户提供支持",
        "text": "在 Google Compute Engine 与 Google Cloud Translation API 的双重助力之下，《列王的纷争》在线聊天服务的基础设施成本降低了20%。",
        "imgSrc": "https://static001.infoq.cn/resource/image/8c/cc/8c95644627c6e4884cb0b621ff4186cc.png"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/GGo4kPsdGDIPaS5PRgPv",
        "origin": "游戏",
        "title": "绿洲游戏：在高性能云平台上为游戏提供动力",
        "text": "绿洲游戏成立于 2011 年，是一家总部位于中国北京的数字娱乐发行公司，GCP 通过合规、可靠和高性能的云平台赢得绿洲游戏的信赖。",
        "imgSrc": "https://static001.infoq.cn/resource/image/0d/bf/0dc46df391020abd133820a026cf90bf.jpeg"
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/8m1R47RGL1tDYxpj5SRT",
        "origin": "出海",
        "title": "最受印度用户欢迎的相机产品之一，美图 BeautyPlus 和它背后的 Google Cloud",
        "text": "美图海外业务架构全部基于 Kubernetes 进行容器化部署，同时依托于 Google 的资源，能及时、专业地解决难题。美图海外的业务迁移成为在 GCP 上 Kubernetes 迁移部署的最佳实践之一。",
        "imgSrc": require('../assets/img/google-img/case1.png')
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/YJURjDffHxWXsZpsL4zK",
        "origin": "出海",
        "title": "被繁杂的数据搞到头大？让 Google Cloud 大数据平台帮你实现快准狠！",
        "text": "木瓜移动专注于服务国内企业出海，业务覆盖游戏、应用、电商等行业，数据服务上有很多 Google Cloud 数据产品应用经验。",
        "imgSrc": require('../assets/img/google-img/case2.png')
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/2zwH54KIcBHk8UKev4mR",
        "origin": "科技，零售和消费品",
        "title": "3PM Solutions：基于大数据技术识别、保护并降低在线市场欺诈",
        "text": "3PM Solutionss 使用 Bigtable,Dataproc 等 Google Cloud 托管服务增强自己的全球品牌，显著提高在 Amazon、eBay 以及 Walmart.com 上的经营收入。",
        "imgSrc": require('../assets/img/google-img/3pm.jpg')
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/f3HMRUFRhMAZBG4mk43S",
        "origin": "科技",
        "title": "AB Delicious：通过数据驱动型决策提高转化率",
        "text": "AB Tasty 利用 Cloud Dataflow、Cloud Storage 以及 Cloud Pub/Sub 构建起数据流水线，日均存储并处理多达 20 亿条事件记录，为站点平台优化带来强有力的数据洞察支持。",
        "imgSrc": require('../assets/img/google-img/ab.jpg')
      },
      {
        "link": "https://www.infoq.cn/zones/google/cloud/article/t5qQxrLM3SlljEky2rVJ",
        "origin": "金融",
        "title": "Banca Mediolanum：使用 Google BigQuery 进行多渠道营销",
        "text": "作为来自意大利的知名银行，Banca Mediolanum 使用 Google BigQuery 作为强大数据枢纽，在社交媒体上构建起契合具体需求的广告宣传方案。",
        "imgSrc": require('../assets/img/google-img/me.jpg')
      }
    ],
    "button": {
      "link": "https://www.infoq.cn/zones/google/cloud/list?id=3",
      "text": "查看更多"
    }
  },
  "pso": {
    "title": {
      "mainTitle": "PSO 专业服务与最佳实践",
      "subTitle": "帮助我们的客户和合作伙伴充分利用 Google Cloud 产品"
    },
    "content": [
      {
        "imgSrc": "https://static001.geekbang.org/resource/image/83/d0/83a88a3d9d7d5342dcfd5f992c1944d0.png",
        "title": "通过专业服务帮助解决不断演变的客户问题",
        "desc": "这些明确的价值定位，希望对因为COVID-19疫情而面临新问题的客户有所帮助",
        "link": "http://static001.geekbang.org/static/biz/file/google-next/1-2nd.pdf",
        "moreDesc": "阅读文章详情"
      },
      {
        "imgSrc": "https://static001.geekbang.org/resource/image/0e/7b/0e221dfeff89e57e81916ec14d3b157b.jpg",
        "title": "通过专业服务在Google Cloud上挖掘您的潜力",
        "desc": "探索各种解决方案和使用案例所提供的服务，以满足您的需求",
        "link": "http://static001.geekbang.org/static/biz/file/google-next/2-2nd.pdf",
        "moreDesc": "阅读文章详情"
      },
      {
        "imgSrc": "https://static001-test.geekbang.org/resource/image/01/bd/012f1cee233b8912fed7c4044993e9bd.png",
        "title": "Anthos 应用现代化平台",
        "desc": "Anthos，是Google Cloud的新推出的开放平台，可让您轻松，灵活，安全地在任何地方运行应用程序。",
        "link": "https://static001.infoq.cn/resource/ebook/01/62/01973e5531bdd9346b3e4d720d069d62.pdf",
        "moreDesc": "阅读文章详情"
      },
      {
        "imgSrc": "https://static001-test.geekbang.org/resource/image/93/7e/9312adb66eff6c602a7b82e73ea1737e.png",
        "title": "以战略计划迁移到云",
        "desc": "迁移到云中就像自建房屋一样。在准备开始之前，您需要进行评估并考虑从预算，地块大小，功能需求，外部/内部风格，房间布局，地理位置和地势等多种因素来规划新房子的蓝图。如何严谨有序的迁移到云上？并把迁移的成本降到最低？ 答案就在这里！",
        "link": "https://static001.infoq.cn/resource/ebook/d8/4d/d8694b2b2a2972e7860c604da5f2fa4d.pdf",
        "moreDesc": "阅读文章详情"
      },
      {
        "imgSrc": "https://static001.geekbang.org/static/business/img/pso1.e7e6fcca.png",
        "title": "Google Cloud 专业服务团队 (PSO) ",
        "desc": "Google 专业团队协助客户解决业务上的问题和挑战，根据经过验证的方法和过去成功的实践经验來推荐最佳解决方案。",
        "link": "https://static001.infoq.cn/resource/ebook/70/66/706e1f8cdb7a900d11f30ebbf90ec166.pdf",
        "moreDesc": "阅读文章详情"
      },
      {
        "imgSrc": "https://static001.geekbang.org/static/business/img/pso2.bf03c71e.png",
        "title": "Google Cloud 学习培训产品",
        "desc": "如果您可以轻松地强化您的团队，在一个充满活力的云端世界中茁壮成长又会怎样呢?",
        "link": "https://static001.infoq.cn/resource/ebook/a5/6e/a5e6983eea8dd387d9a06565f5cd5b6e.pdf",
        "moreDesc": "阅读文章详情"
      }
    ],
    "button": {
      "link": "https://www.infoq.cn/zones/google/cloud/list?id=4",
      "text": "查看更多"
    }
  },
  "partner": {
    "title": {
      "mainTitle": "合作伙伴",
      "subTitle": "借力于 Google Cloud 的全球云服务专家生态系统"
    },
    "partners": [
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png",
      "http://cdn001.geekbang.org/ck/5a094e136f0e5.png"
    ]
  },
  "footer": {
    "sign": "Google Cloud",
    "title": "关于<span style=\"font-family: google-word\"> Google Cloud </span>",
    "text": "在提供安全、开放、智能的变革性企业级云平台方面，Google Cloud 是公认的全球领导者。我们的技术依托 Google 专用网络构建而成，是近 20 年来在安全、网络架构、协作、人工智能和开源软件方面不懈创新的产物。我们在 Google Cloud Platform 和 G Suite 中提供了一套设计简洁的工具和无可比拟的技术，帮助客户有效地融合人力、洞见和创意。来自 150 多个国家/地区的客户依靠 Google Cloud 来实现计算环境现代化，以满足当今数字世界的需求。"
  }
}
